import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { Delete, Image } from '@mui/icons-material';
import { DropWrapper, DropZone } from 'components/dropZone/components';


type DropImageProps = {
    upload: (file: File) => void;
    remove?: () => void;
    image?: string;
    title: string;
}

const DropImage = ({ upload, remove, image, title }: DropImageProps) => {
    const { t } = useTranslation();
    const [preview, setPreview] = useState(image);

    const onDropAccepted = (acceptedFiles: File[]) => {
        setPreview(URL.createObjectURL(acceptedFiles[0]));
        upload(acceptedFiles[0]);
    };

    const onDelete = () => {
        setPreview('');
        remove?.();
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDropAccepted,
        accept: {
            'image/*': ['.jpeg', '.png'],
        },
        multiple: false,
    });

    const thumb = preview ? <img src={preview} alt="uploaded preview" /> : <Image />;

    return (
        <DropWrapper>
            {preview && remove && <div className="delete btn-icon text-danger" onClick={onDelete}><Delete /></div>}

            <DropZone {...getRootProps({ className: 'drop-image' })}>
                <input {...getInputProps()} />
                <div className="title">{thumb}<br/>{title}</div>
                {isDragActive &&
                    <div className="drop-here">{t('drop_files_here')}...</div>
                }
            </DropZone>
        </DropWrapper>
    )
}

export default DropImage;
